import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { JwtService } from 'app/jwt.service';

interface UserData {
  id: string;
}
@Injectable({
  providedIn: 'root'
})
export class AccessService {

  hostURL = environment.apiUrl;
  constructor(private jwtService: JwtService,private http: HttpClient,private route: ActivatedRoute) { }

  // actionlist:{}={create:false,view:false,edit:false,delete:false}

  userData:string[] = Object.values(JSON.parse(localStorage.getItem("accesslist") || '{}'));
  // userData: UserData = JSON.parse(localStorage.getItem("accesslist") || '{}');
  // data = {"user_id": this.userData.id};

  accesslist=this.userData;

  getAccessByUserId(data:any,tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('tenant_id', ''+tenant_id);
    let apiURL = this.hostURL + '/acl/access_list';
    return this.http.post(apiURL, data,{headers});
  }
  getAccessByRole(data:any,tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('tenant_id', ''+tenant_id);
    let apiURL = this.hostURL + '/acl/access_list_role';
    return this.http.post(apiURL, data,{headers});
  }

  

  checkaccess(params: string,type:string,userAccesslist:any=[]): any {

    // alert(33)
    console.log(userAccesslist,"mmmmmm");
    if(userAccesslist.length!=0){
      this.accesslist=Object.values(userAccesslist);
    }else{
      this.accesslist=this.userData;
    }
    // console.log(this.accesslist,"aaaaaaaa");
    let access:any;
    if(type=="page"){
      access=this.checkaccess_page(params);
    }else if(type=="action"){
      access=this.checkPageAceess(params)
    }
    return access;
  }

  checkaccess_page(title: string): boolean{
    const access = this.accesslist;
    return access.some(access_slug => {
      const access_parts = access_slug.split('_');
      return access_parts[0].toLocaleLowerCase().replace(/[\s-]+/g, '') === title.toLocaleLowerCase().replace(/[\s-]+/g, '');
    });
  }

  checkPageAceess(page:string):{}{
    let actionlist:{}={create:false,view:false,edit:false,delete:false}
    console.log(typeof(this.accesslist),'iiiiiii')
    this.accesslist.map(access_slug=>{
      const access_parts = access_slug.split('_');
       if(access_parts[0] === page){
        actionlist[access_parts[1]]=true;
       }
    });
    return actionlist;
  }

storeQueryParams() {

    window.addEventListener('message', (event) => {
      // const origin = 'http://pramaat1.com/#/login-dashboard'; // Replace with the actual sender origin
      // alert(event.origin);
      // if (event.origin !== origin) {
      //   return; // Ignore messages from unknown origins
      // }
    // console.log(event.origin,"origin")
      const receivedData = JSON.parse(event.data);
      console.log(event.data,"dataaaaaaaaaa");
      console.log(receivedData,"token");
      const decodedToken = this.jwtService.decodeToken(receivedData.token);
      // const data= receivedData.data;
      const data= JSON.parse(receivedData.data);
      console.log(decodedToken,"decoded_token");
      console.log("data",data);
      console.log("data",typeof(data));
      // let access_list=Object.values(JSON.parse(decodedToken.access_list || '{}'));
      let access_list=Object.values(JSON.parse(data.access));
      access_list=access_list.filter((item:any)=>item.config.tenant_id==receivedData.company_id);
      console.log(access_list,"access_list");
      // console.log(receivedData.userdetails,"userdetails");
      // console.log(receivedData.access_list,"access_list");
      // localStorage.setItem('receivedData', JSON.stringify(receivedData));
      localStorage.setItem("token", receivedData.token);
      localStorage.setItem("data", JSON.stringify(JSON.parse(receivedData.data)));
      localStorage.setItem("accesslist", JSON.stringify(access_list));
      localStorage.setItem("companyname",receivedData.company_name);
    });
    
    
    // Example usage to retrieve the stored data
    // const storedData = JSON.parse(localStorage.getItem('receivedData') || '{}');
    // console.log(storedData);
  }

  getStoredQueryParams(): any {
    return JSON.parse(localStorage.getItem('queryParams') || '{}');
  }
  
  clearStoredQueryParams() {
    localStorage.removeItem('queryParams');
  }

  getDatabranch(tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('X-Tenant-Id', tenant_id);
    console.log(tenant_id,"tenant_id");
    console.log("header",headers);
    return this.http.get<any>(`${this.hostURL}/branch/`,{headers});
  }

  getUserBranch(data:any): Observable<any> {
    const url = `${this.hostURL}/acl/get_tenant_user_branch`;
    return this.http.post(url, data);
}

  getPc_cc(tenant_id:string): Observable<any> {
    const headers = new HttpHeaders().set('X-Tenant-Id', tenant_id);
    return this.http.get<any>(`${this.hostURL}/profitcostcenter/`,{headers});
  }

 getUserAuditor(data:any): Observable<any> {
    const url = `${this.hostURL}/acl/get_tenant_user_auditor`;
    return this.http.post(url, data);
}

// Get user menus from localStorage config
getUserMenusFromConfig(): Observable<any> {
  const accessListData = localStorage.getItem('accesslist');
  if (accessListData) {
    const accessList = JSON.parse(accessListData);
    if (accessList.length > 0 && accessList[0].config) {
      const config = accessList[0].config;
      const data = {
        user_id: config.user_id,
        tenant_user_id: config.user_tenant_id
      };
      return this.http.post<any>(`${this.hostURL}/acl/get_user_menus`, data);
    }
  }
  return new Observable(observer => observer.next([]));
}

// Get user ID and tenant user ID from localStorage config
getUserConfig(): {user_id: number, tenant_user_id: number} | null {
  const accessListData = localStorage.getItem('accesslist');
  if (accessListData) {
    const accessList = JSON.parse(accessListData);
    if (accessList.length > 0 && accessList[0].config) {
      return {
        user_id: accessList[0].config.user_id,
        tenant_user_id: accessList[0].config.tenant_user_id
      };
    }
  }
  return null;
}

}
